import type { RouteObject } from 'react-router';

/** Öffentliche Route /galerie (People-Plattform). */
export const galerieRoute: RouteObject = {
  path: 'galerie',
  lazy: async () => ({ Component: (await import('./GaleriePage')).default }),
};
